<template>
  <div
    v-if="call.incomingCall"
    class="flex items-center justify-between w-full px-4 border border-orange-200 rounded bg-orange-50"
  >
    <div class="flex justify-between flex-grow">
      <div class="flex flex-col">
        <div>Number: {{ call.incomingCall.number }}</div>
        <div>Queue:{{ call.incomingCall.queueName }}</div>
      </div>
      <div class="flex flex-col justify-between text-right">
        <div class="text-xs text-gray-400">
          ({{ duration }})
        </div>
      </div>
    </div>
    <div class="flex items-center">
      <button
        title="Decline"
        class="p-2 ml-2 bg-red-100 rounded-full"
        @click="decline"
      >
        <ld-icon
          class="w-4 h-4"
          icon="XIcon"
        />
      </button>
      <button
        title="Accept"
        class="p-2 ml-2 bg-teal-100 rounded-full"
        @click="accept"
      >
        <ld-icon
          class="w-4 h-4"
          icon="CheckIcon"
        />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { defineComponent, onMounted, onUnmounted, ref } from 'vue'
  import { useCallStore } from '/@/store/callStore'
  import { Howl } from 'howler'
  import Ringtone from '/@/assets/sounds/Ringtone.ogg?url'
  import useLetsDialSocket from '/@/services/letsDialSocket/useLetsDialSocket'
  import { useAuthStore } from '/@/store/authStore'

  const duration = ref(10)
  let timeInterval: any
  let { socket } = useLetsDialSocket()
  const call = useCallStore()
  const authStore = useAuthStore()
  const ringVolume = authStore.user?.attributes?.additionalAttributes?.ringVolume ?? 0.5
  let sound = new Howl({
    src: [Ringtone],
    loop: true,
    volume: ringVolume,
  })
  const decline = (timedOut = false) => {
    if (call.incomingCall) {
      socket.emit('user:accept:call', {
        callID: call.incomingCall.callID,
        accepted: false,
        timedOut: true,
      })
      call.$reset()
      console.log('Status', authStore.currentStatus, authStore.user?.attributes.status)
      if (authStore.currentStatus !== 'PAUSED' && authStore.user?.attributes.status !== 'PAUSED') {
        authStore.setAvailabilityStatus('IDLE')
      }
    }
  }
  const accept = () => {
    if (call.incomingCall) {
      socket.emit('user:accept:call', {
        callID: call.incomingCall.callID,
        accepted: true,
      })
      call.acceptIncomingCall()
    }
  }
  onMounted(() => {
    const ringVol = authStore.user?.attributes?.additionalAttributes?.ringVolume ?? 0.5
    sound.volume(ringVol)
    sound.play()
    timeInterval = setInterval(() => {
      duration.value = duration.value - 1
      if (duration.value <= 0) {
        decline(true)
      }
    }, 1000)
  })
  onUnmounted(() => {
    sound.stop()
    clearInterval(timeInterval)
  })
</script>
